export default __webpack_public_path__ + "static/our-leadership-0b40966f8065d38e0ad491324ed179d7.webp";